import styled from "styled-components";

import "react-vertical-timeline-component/style.min.css";

import { Canvas } from "@react-three/fiber";
import { Suspense, useEffect, useRef, useState } from "react";


import { Bird} from "../models/Bird";
import { Sky } from "../models/Sky";

import { soundoff, soundon } from "../assets/icons";
import sakura from '../assets/sakura.mp3'

import Loader from "./Loader";
import HomeInfo from "./HomeInfo";
function Home() {

  const [isRotating, setIsRotating] = useState(true);

  const audioRef = useRef(new Audio(sakura));
  audioRef.current.volume = 0.4;
  audioRef.current.loop = true;
  const [isPlayingMusic, setIsPlayingMusic] = useState(false);
  useEffect(() => {
    if (isPlayingMusic) {
      audioRef.current.play();
    }

    return () => {
      audioRef.current.pause();
    };
  }, [isPlayingMusic]);
  return (
    <>
        <div className="w-full h-screen relative">
        <div className="className='absolute top-28 left-0 right-0 z-10 flex items-center justify-center'">
          <div className='absolute top-28 left-0 right-0 z-10 flex '>
            <HomeInfo />
          </div>
        </div> 
        <Canvas
        className={`w-full h-screen bg-transparent ${
          isRotating ? "cursor-grabbing" : "cursor-grab"
        }`}
        camera={{ near: 0.1, far: 1000 }}
      >
        <Suspense fallback={<Loader />}>
          <directionalLight position={[1, 1, 1]} intensity={2} />
          <ambientLight intensity={0.5} />
          <pointLight position={[10, 5, 10]} intensity={2} />
          <spotLight
            position={[0, 50, 10]}
            angle={0.15}
            penumbra={1}
            intensity={2}
          />
          <hemisphereLight
            skyColor='#b1e1ff'
            groundColor='#000000'
            intensity={1}
          />

          <Bird />
          <Sky isRotating={isRotating} />
        </Suspense>
      </Canvas>
      </div>
      <div className='soundplayer'>
              <img
                src={!isPlayingMusic ? soundoff : soundon}
                alt='jukebox'
                onClick={() => setIsPlayingMusic(!isPlayingMusic)}
                className='w-10 h-10 cursor-pointer object-contain'
              />
        </div>
    </>
  )
}







const Hero = styled.div`
  padding-top:80px;
  position: relative;
  background-size: cover; 
  background-position: center; 
`
const Container = styled.div`
  position: relative;
  z-index: 1;
  margin:0 auto;
  max-width:1240px;
  padding:0 140px;

  @media (max-width: 730px) {
    padding:0 26px;
    text-align: center;
  }
`

const Bottom = styled.div`
   padding:10px;
   margin:0 auto;
   img {
     width:100%;

   }
   .mob {
    display:none;
    padding:0 30px 0 10px ;
   }
   @media (max-width: 630px) {
    .desk {
       display:none;
    }
    .mob {
        display:block;
       }
   }
   
`



//portfolio


export default Home;









